import React, { useState } from 'react';
import styles from '../../../CustomerDash/Components/allEnquiresTab/specificationsTab.module.css';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AllVenOrderTable = () => {

  const records = [
    { id: 3933, name: 'Devika', date: '4 April, 2021', total: '$135.00 (5 Products)', status: 'On the way' },
    { id: 3934, name: 'Aarav', date: '5 April, 2021', total: '$150.00 (6 Products)', status: 'Completed' },
    { id: 3935, name: 'Ishaan', date: '6 April, 2021', total: '$200.00 (8 Products)', status: 'Processing' },
    { id: 3936, name: 'Sanya', date: '7 April, 2021', total: '$250.00 (10 Products)', status: 'Processing' },
    { id: 3937, name: 'Kabir', date: '8 April, 2021', total: '$300.00 (12 Products)', status: 'Shipped' },
    { id: 3938, name: 'Aria', date: '9 April, 2021', total: '$175.00 (7 Products)', status: 'Completed' },
    { id: 3939, name: 'Rohan', date: '10 April, 2021', total: '$220.00 (9 Products)', status: 'On the way' },
    { id: 3940, name: 'Nia', date: '11 April, 2021', total: '$190.00 (8 Products)', status: 'Processing' },
    { id: 3941, name: 'Meera', date: '12 April, 2021', total: '$300.00 (11 Products)', status: 'Completed' },
    { id: 3942, name: 'Aditya', date: '13 April, 2021', total: '$400.00 (15 Products)', status: 'Completed' },
  ];


  return (
    <>
      <table className={styles.spectable}>
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Date</th>
            <th>Total</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody className={styles.spectbody}>
          {records.map((record) => (
            <tr key={record.id}>
              <td>#{record.id} ({record.name})</td>
              <td>{record.date}</td>
              <td>{record.total}</td>
              <td>{record.status}</td>
              <td className={styles.speccheck}>
                <a href={`details/${record.id}`}>View Details</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AllVenOrderTable;
